import { PredefinedCommentFormModel } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import React from 'react';

export type PredefinedCommentFormMode = 'add' | 'edit';

export interface PredefinedCommentFormContextType {
    mode: PredefinedCommentFormMode;
    predefinedComment?: PredefinedCommentFormModel;
    isFormLoading: boolean;
    predefinedCommentId?: string;
}

export const PredefinedCommentFormContext = React.createContext<PredefinedCommentFormContextType | undefined>(
    undefined
);
